import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/admin", { replace: true, state: { error: "Sessione Google non valida." } });
      return;
    }

    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => {
        localStorage.removeItem("oep_token");
        navigate("/admin/dashboard", { replace: true, state: { user: data.user } });
      })
      .catch((err) => {
        navigate("/admin", {
          replace: true,
          state: { error: formatApiError(err.response?.data?.detail, "Accesso Google non riuscito.") },
        });
      });
  }, [location.hash, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-void" data-testid="google-auth-callback">
      <p className="font-serif text-2xl italic text-muted">Accesso con Google in corso…</p>
    </div>
  );
}
